export const generateRandAlphaNumStr = () => {
  let rdmString = '';
  for (
    ;
    rdmString.length < 40;
    rdmString += Math.random().toString(36).substr(2) //NOSONAR
  );
  return rdmString.substr(0, 20);
};
